import PropTypes from 'prop-types'
import LoadingBar from 'components/LoadingBar'
import AutocompleteError from 'components/AutocompleteError'
import React, { PureComponent } from 'react'
import styles from './styles.scss'

class AutocompleteList extends PureComponent {
  render() {
    const {
      children,
      searching,
      searchError,
      searchState,
      onMouseEnter,
      onMouseLeave,
    } = this.props

    const errorElement = searchError && <AutocompleteError message={searchError} />

    if ((!children || children.length === 0) && !searching && !searchError && !searchState) {
      return null
    }

    return (
      <div className={styles.wrapper} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        <LoadingBar show={searching} />
        <ol className={styles.list}>
          {errorElement}
          {children}
        </ol>
      </div>
    )
  }
}

AutocompleteList.propTypes = {
  children: PropTypes.any,
  searching: PropTypes.bool,
  searchError: PropTypes.string,
  searchState: PropTypes.string,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
}

AutocompleteList.defaultProps = {
  children: null,
  searching: false,
  searchError: '',
  searchState: '',
  onMouseEnter: f => f,
  onMouseLeave: f => f,
}

export default AutocompleteList



// WEBPACK FOOTER //
// ./components/AutocompleteList/index.jsx